<template>
    <section>
        <b-row>
            <b-col
                :md="12"
            >
                <b-overlay
                    :show="statusSummary === 'loading'"
                >
                    <b-card
                        no-body
                    >
                        <b-alert
                            :show="isLimitOver"
                            variant="warning"
                            class="p-1 mb-0"
                        >
                            <i class="fas fa-exclamation-circle"></i>
                            {{ $t('v4["Please wait for loading..."]') }}
                        </b-alert>
                        <b-table-simple
                            responsive
                            class="m-0"
                        >
                            <colgroup>
                                <col>
                                <col>
                                <col>
                                <col width="120px">
                            </colgroup>
                            <b-thead>
                                <b-tr>
                                    <b-th>
                                        {{ $t('v4.Usage Month') }}
                                    </b-th>
                                    <b-th>
                                        {{ $t('v4.Type') }}
                                    </b-th>
                                    <b-th
                                        class="text-right"
                                    >
                                        {{ $t('v4.Total (USD)') }}
                                    </b-th>
                                    <b-th
                                        class="text-center"
                                    >
                                        {{ $t('v4.Download') }}
                                    </b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody v-if="noData">
                                <b-tr>
                                    <b-td
                                        class="pb-50 pt-2 text-center"
                                        colspan="4"
                                    >
                                        {{ $t("org.message.No Data") }}
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                            <b-tbody v-else>
                                <template
                                    v-for="(item, index) in invoiceSummary"
                                >
                                    <template
                                        v-for="(subItem, subIndex) in item.detail"
                                    >
                                        <b-tr
                                            v-if="subIndex === 0"
                                            :key="`${index}-${subIndex}`"
                                        >
                                            <b-td
                                                :rowspan="item.detail.length"
                                            >
                                                {{ item.month }}
                                            </b-td>
                                            <b-td
                                                :class="subItem.type === 'Anniversary' ? 'table-primary text-black-50' : 'table-success'"
                                            >
                                                {{ subItem.type }}
                                            </b-td>
                                            <b-td
                                                class="text-right"
                                            >
                                                {{ $_getDollar(subItem.usdCost) }}
                                            </b-td>
                                            <b-td
                                                :rowspan="item.detail.length"
                                                class="text-center"
                                            >
                                                <a href="javascript:;" @click="downloadInvoicePDF(item.month)">
                                                    <i
                                                        v-if="pdfStatus.includes(item.month)"
                                                        class="fas fa-spinner fa-spin fa-fw fa-md"
                                                    ></i>
                                                    <i v-else
                                                        class="fas fa-download fa-fw fa-md"
                                                    ></i>
                                                </a>
                                            </b-td>
                                        </b-tr>
                                        <b-tr v-else
                                            :key="`${index}-${subIndex}`"
                                        >
                                            <b-td
                                                :class="subItem.type === 'Anniversary' ? 'table-primary' : 'table-success'"
                                            >
                                                {{ subItem.type }}
                                            </b-td>
                                            <b-td
                                                class="text-right"
                                            >
                                                {{ $_getDollar(subItem.usdCost) }}
                                            </b-td>
                                        </b-tr>
                                    </template>
                                </template>
                            </b-tbody>
                        </b-table-simple>
                    </b-card>
                </b-overlay>
            </b-col>
        </b-row>
    </section>
</template>

<script>
import { toRefs, ref, getCurrentInstance, computed, watch } from '@vue/composition-api'
const STORE_KEY = '$_invoice'
export default {
    name: 'InvoicesModule',
    props: [
        'project',
        'yearOptions'
    ],
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const { project, yearOptions } = toRefs(props)
        const selectedYear = computed(() => store.getters[`${STORE_KEY}/selectedYear`])
        const pdfStatus = ref([])
        const disabeldYearRadio = computed(() => pdfStatus.value.length > 0)
        const invoiceSummary = computed(() => store.getters[`${STORE_KEY}/summary`])
        const noData = computed(() => !yearOptions.value.length)
        const locale = computed(() => vm.$i18n.locale)
        const statusSummary = computed(() => store.getters[`${STORE_KEY}/statusSummary`])
        const MAX_LIMIT = 3
        const isLimitOver = computed(() => pdfStatus.value.length > MAX_LIMIT)
        const downloadInvoicePDF = (month) => {
            if (pdfStatus.value.length > MAX_LIMIT) {
                return
            }
            const usageAccountId = project.value.usageAccountId
            if (!pdfStatus.value.includes(month)) {
                pdfStatus.value.push(month)
            }
            store.dispatch('$_invoice/downloadInvoicePDF', { usageAccountId, month, locale: locale.value }).then(data => {
                pdfStatus.value = pdfStatus.value.filter(value => value !== month)
                const fileURL = window.URL.createObjectURL(new Blob([data]))
                const fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'invoice.pdf')
                document.body.appendChild(fileLink)
                fileLink.click()
            })
        }

        async function getInvoiceMonths (usageAccountId) {
            try {
                await store.dispatch('$_invoice/getInvoiceMonths', { usageAccountId })
                if (yearOptions.value.length) return true
                return false
            } catch (error) {
                return false
            }
        }

        async function getInvoiceAnnualSummary (usageAccountId, year) {
            try {
                await store.dispatch('$_invoice/getInvoiceAnnualSummary', {
                    usageAccountId,
                    year
                })
                return true
            } catch (error) {
                return false
            }
        }

        watch(selectedYear, (value, oldValue) => {
            getInvoiceAnnualSummary(project.value.usageAccountId, value)
        })

        watch(project, (value, oldValue) => {
            getInvoiceMonths(value.usageAccountId).then((result) => {
                if (result) {
                    getInvoiceAnnualSummary(value.usageAccountId, yearOptions.value[0])
                }
            })
        })
        return {
            statusSummary,
            noData,
            pdfStatus,
            isLimitOver,
            disabeldYearRadio,
            invoiceSummary,
            downloadInvoicePDF
        }
    }
}
</script>

<style lang="scss" scoped>
.year-radio-group {
    ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}
</style>
